export enum TableMessagesEnum {
    CLEAR_SELECTION = 'clear_selection',
}
